import { Options } from '@angular-slider/ngx-slider';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ELearningManagementService } from '../../e-learning-management/e-learning-management.service';
import { MeasureManagementService } from '../measure-management.service';
import * as tus from 'tus-js-client';
import { uploadFiles } from 'src/app/shared/models/uploadFiles.model';
import { of } from 'rxjs';

@Component({
  selector: 'app-modal-add-question-informant',
  templateUrl: './modal-add-question-informant.component.html',
  styleUrls: ['./modal-add-question-informant.component.scss']
})
export class ModalAddQuestionInformantComponent implements OnInit {
  isLoading: boolean;
  isEdit: boolean;
  modalData: any;

  InformantForm;
  multipleChoiceForm;
  rankingForm;
  ratingForm;
  mostLeastForm;
  multiForm;

  type: string;
  subType: string;
  media: any;
  questionMediaType: string;
  questionMedia: any;
  choicesMedia = [];
  value: number;
  options: Options;
  questionIndex: number = 0;

  pendingFiles: uploadFiles[] = [];
  hashKey: string;
  uploadVideoUri: string;
  isUploadSuccess: boolean = false;
  percentage: number;

  tag: any = [
    {
      label: 'Traget',
      value: 0
    },
  ];

  informantArr: any[] = [];

  questionType = [{
    name: 'Multiple Choice',
    value: 'multi_choice'
  }, {
    name: 'Rating',
    value: 'rating'
  }, {
    name: 'Ranking',
    value: 'ranking'
  }, {
    name: 'Most/Least',
    value: 'most/least'
  }, {
    name: 'Multi',
    value: 'multi'
  }];
  subQuestionType = [{
    name: 'Multiple Choice',
    value: 'multi_choice'
  }, {
    name: 'Rating',
    value: 'rating'
  }, {
    name: 'Ranking',
    value: 'ranking'
  }, {
    name: 'Most/Least',
    value: 'most/least'
  }];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddQuestionInformantComponent>,
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private measureManagementService: MeasureManagementService,
    private eLearningService: ELearningManagementService,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    // this.getForm();
    this.modalData.informant_tag.forEach((e, i) => {
      this.tag.push({
        label: e,
        value: i + 1,
      })
    });
    this.getForm();
  }

  getForm() {
    this.multipleChoiceForm = {
      type: 'multi_choice',
      question: ['', Validators.required],
      media: this.fb.group({
        media_type: '',
        file_name: '',
        time_again: '',
        unlimit: '',
        duration: '',
        vdo_id: '',
        file_url: ''
      }),
      choices: this.fb.array([]),
    }
    this.ratingForm = {
      type: 'rating',
      question: ['', Validators.required],
      length: ['', Validators.required],
      default: [1, Validators.required], // ตอนแรกมีให้เลือก แต่เอาออกแล้วเลยใส่ค่า default เป็น 1
      choices: this.fb.array([]),
    }
    this.rankingForm = {
      type: 'ranking',
      question: ['', Validators.required],
      choices: this.fb.array([]),
    }
    this.mostLeastForm = {
      type: 'most/least',
      question: ['', Validators.required],
      most: ['', Validators.required],
      least: ['', Validators.required],
      media: this.fb.group({
        media_type: '',
        file_name: '',
        time_again: '',
        unlimit: '',
        duration: '',
        vdo_id: '',
        file_url: ''
      }),
      choices: this.fb.array([]),
    }
    this.multiForm = {
      type: 'multi',
      question: ['', Validators.required],
      subType: ['', Validators.required],
      subQuestion: this.fb.array([])
    }

    if (this.modalData.isEdit) {
      this.type = this.modalData.value.TYPE;
      this.setEditForm();
    }
  }

  setEditForm() {
    console.log(this.type);
    switch (this.type) {
      case 'multi_choice': {
        console.log('multichoice');
        let group = this.fb.group({
          media_type: this.modalData.value.VALUE[0].media_type ? this.modalData.value.VALUE[0].media.media_type : '',
          file_name: this.modalData.value.VALUE[0].file_name ? this.modalData.value.VALUE[0].media.file_name : '',
          time_again: this.modalData.value.VALUE[0].time_again ? this.modalData.value.VALUE[0].media.time_again : '',
          unlimit: this.modalData.value.VALUE[0].unlimit ? this.modalData.value.VALUE[0].media.unlimit : '',
          file_url: this.modalData.value.VALUE[0].media.file_url ? this.modalData.value.VALUE[0].media.file_url : '',
          duration: this.modalData.value.VALUE[0].media.duration ? this.modalData.value.VALUE[0].media.duration : '',
          vdo_id: this.modalData.value.VALUE[0].media.vdo_id ? this.modalData.value.VALUE[0].media.vdo_id : ''
        })

        this.multipleChoiceForm = {
          type: 'multi_choice',
          question: [this.modalData.value.VALUE[0].question, Validators.required],
          media: group,
          choices: this.fb.array([]),
        }
        break;
      }

      case 'rating': {
        this.ratingForm = {
          type: 'rating',
          question: [this.modalData.value.VALUE[0].question, Validators.required],
          length: [this.modalData.value.VALUE[0].length, Validators.required],
          default: [this.modalData.value.VALUE[0].default, Validators.required],
          choices: this.fb.array([]),
        }
        break;
      }

      case 'ranking': {
        this.rankingForm = {
          type: 'ranking',
          question: [this.modalData.value.VALUE[0].question, Validators.required],
          choices: this.fb.array([]),
        }
        break;
      }

      case 'most/least': {
        let group = this.fb.group({
          media_type: this.modalData.value.VALUE[0].media_type ? this.modalData.value.VALUE[0].media.media_type : '',
          file_name: this.modalData.value.VALUE[0].file_name ? this.modalData.value.VALUE[0].media.file_name : '',
          time_again: this.modalData.value.VALUE[0].time_again ? this.modalData.value.VALUE[0].media.time_again : '',
          unlimit: this.modalData.value.VALUE[0].unlimit ? this.modalData.value.VALUE[0].media.unlimit : '',
          file_url: this.modalData.value.VALUE[0].media.file_url ? this.modalData.value.VALUE[0].media.file_url : '',
          duration: this.modalData.value.VALUE[0].media.duration ? this.modalData.value.VALUE[0].media.duration : '',
          vdo_id: this.modalData.value.VALUE[0].media.vdo_id ? this.modalData.value.VALUE[0].media.vdo_id : ''
        });

        this.mostLeastForm = {
          type: 'most/least',
          most: [this.modalData.value.VALUE[0].most, Validators.required],
          least: [this.modalData.value.VALUE[0].least, Validators.required],
          question: [this.modalData.value.VALUE[0].question, Validators.required],
          media: group,
          choices: this.fb.array([]),
        }
        break;
      }
    }
    this.setForm(this.type);
  }

  setForm(type) {
    let form;

    switch (type) {
      case 'multi_choice': {
        form = this.multipleChoiceForm;
        break;
      }
      case 'rating': {
        form = this.ratingForm;
        break;
      }
      case 'ranking': {
        form = this.rankingForm;
        break;
      }
      case 'most/least': {
        form = this.mostLeastForm;
        break;
      }
      default: { break; }
    }

    const informantGroup = this.fb.group({
      ...form
    });

    this.InformantForm = informantGroup;
    console.log(this.InformantForm)
  }

  get informantFormArray(): FormArray {
    return this.InformantForm.get('choices') as FormArray;
  }

  setInformantArr(e) {
    this.informantArr = e;
  }

  setType(type) {
    this.type = type.target.value;
    this.modalData.isEdit = false;
    this.questionMedia = null;
    this.questionMediaType = null;

    this.questionIndex = 0;

    this.informantArr = [];
    this.setForm(this.type);

    this.informantFormArray.clear();
    
    this.InformantForm.reset();
    this.InformantForm.get('type').setValue(this.type);
    console.log(this.informantFormArray);
    console.log(this.InformantForm);
    console.log(this.informantArr);
  }

  changeQuestion(e) {
    console.log(e);
  }

  getChoicesMedia(e) {
    console.log(e);
    this.choicesMedia = e;
  }

  getQuestionMedia(e) {
    console.log(e);
    this.questionMedia = e;
  }

  getQuestionMediaType(e) {
    console.log(e);
    this.questionMediaType = e;
  }

  addQuestionList(form) {
    let isEmpty = false;
    console.log(form);
    let valueInformant = [];
    valueInformant.push({
      tag: 'Traget',
      ...form.value
    });

    this.informantArr.forEach(e => {
      valueInformant.push(e);
    })
    console.log(valueInformant);

    for (let i = 0; i < valueInformant.length; i++) {
      let question = valueInformant[i]
      if (!question.question) {
        isEmpty = true;
        break;
      } else {
        for (let j = 0; j < question.choices.length; j++) {
          const choice = question.choices[j];
          if (!choice.choice_detail) {
            isEmpty = true;
            break;
          }
        }
      }
    }

    if (!isEmpty) {
      switch (this.type) {
        case 'multi_choice': {
          if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
            alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
            break;
          } else if (form.value.choices.length <= 1) {
            alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
            break;
          }

          form.controls['type'].setValue('multi_choice');
          this.isLoading = true;

          if (this.questionMediaType === 'mp4') {
            this.eLearningService.createVideo(this.questionMedia).pipe(
              map(response => {
                const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
                this.pendingFiles.push(videoFile);
                this.uploadVideoUri = response.body.uri.slice(8);
                this.hashKey = response.body.link.slice(-10);

                return new tus.Upload(this.pendingFiles[0].video, {
                  uploadUrl: this.pendingFiles[0].uploadURI,
                  endpoint: this.pendingFiles[0].uploadURI,
                  retryDelays: [0, 1000, 3000, 5000],
                  onError: error => {
                    // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                    return of(null)
                  },
                  onProgress: (bytesUploaded, bytesTotal) => {
                    this.percentage = ((bytesUploaded / bytesTotal) * 100);
                    const percentage = ((bytesUploaded / bytesTotal) * 100);
                    // console.log(bytesUploaded, bytesTotal, percentage + '%');
                  },
                  onSuccess: () => {
                    // console.log('Videos uploaded successfully');

                    form.controls['media'].patchValue({
                      file_name: this.uploadVideoUri
                    });
                    form.controls['media'].updateValueAndValidity();
                    this.questionMedia = '';

                    // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
                    if (!this.modalData.id) {
                      const data = {
                        measure_id: this.modalData.measureId,
                        questionMedia: this.questionMedia ? this.questionMedia : '',
                        choicesMedia: this.choicesMedia ? this.choicesMedia : ''
                      };
                      console.log(form);
                      this.createDetailMeasureByTypeInformant(form, data, valueInformant);

                    } else {
                      const data = {
                        id: this.modalData.id,
                        measure_id: this.modalData.measureId,
                        questionMedia: this.questionMedia ? this.questionMedia : '',
                        choicesMedia: this.choicesMedia ? this.choicesMedia : ''
                      };
                      console.log(form);
                      this.createDetailMeasureByTypeInformant(form, data, valueInformant);
                    }
                  }
                }).start();
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
            break;
          } else {
            // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
            if (!this.modalData.id) {
              const data = {
                measure_id: this.modalData.measureId,
                questionMedia: this.questionMedia ? this.questionMedia : '',
                choicesMedia: this.choicesMedia ? this.choicesMedia : ''
              }

              this.createDetailMeasureByTypeInformant(form, data, valueInformant);
            } else {
              const data = {
                id: this.modalData.id,
                measure_id: this.modalData.measureId,
                questionMedia: this.questionMedia ? this.questionMedia : '',
                choicesMedia: this.choicesMedia ? this.choicesMedia : ''
              };

              this.editMeasureQuestionInformantByType(form, data, valueInformant);
            }
          }
          break;
        }

        case 'rating': {
          // console.log(form);

          form.controls['type'].setValue('rating');

          // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
          if (!this.modalData.id) {
            const data = {
              measure_id: this.modalData.measureId
            }

            this.createDetailMeasureByTypeInformant(form, data, valueInformant);
          } else {
            const data = {
              id: this.modalData.id,
              measure_id: this.modalData.measureId
            };

            this.editMeasureQuestionInformantByType(form, data, valueInformant);
          }
          break;
        }

        case 'ranking': {
          if (form.value.choices.length <= 1) {
            alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
            break;
          }
          // console.log(form);

          form.controls['type'].setValue('ranking');

          // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
          if (!this.modalData.id) {
            const data = {
              measure_id: this.modalData.measureId
            }

            this.createDetailMeasureByTypeInformant(form, data, valueInformant);
            break;
          } else {
            const data = {
              id: this.modalData.id,
              measure_id: this.modalData.measureId
            };

            this.editMeasureQuestionInformantByType(form, data, valueInformant);
          }
          break;
        }

        case 'most/least': {
          if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
            alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
            break;
          } else if (form.value.choices.length <= 1) {
            alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
            break;
          }

          form.controls['type'].setValue('most/least');
          this.isLoading = true;

          if (this.questionMediaType === 'mp4') {

            this.eLearningService.createVideo(this.questionMedia).pipe(
              map(response => {
                const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
                this.pendingFiles.push(videoFile);
                this.uploadVideoUri = response.body.uri.slice(8);
                this.hashKey = response.body.link.slice(-10);

                return new tus.Upload(this.pendingFiles[0].video, {
                  uploadUrl: this.pendingFiles[0].uploadURI,
                  endpoint: this.pendingFiles[0].uploadURI,
                  retryDelays: [0, 1000, 3000, 5000],
                  onError: error => {
                    // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                    return of(null)
                  },
                  onProgress: (bytesUploaded, bytesTotal) => {
                    this.percentage = ((bytesUploaded / bytesTotal) * 100);
                    const percentage = ((bytesUploaded / bytesTotal) * 100);
                    // console.log(bytesUploaded, bytesTotal, percentage + '%');
                  },
                  onSuccess: () => {
                    // console.log('Videos uploaded successfully');

                    form.controls['media'].patchValue({
                      file_name: this.uploadVideoUri
                    });
                    form.controls['media'].updateValueAndValidity();
                    this.questionMedia = '';

                    // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
                    if (!this.modalData.id) {
                      const data = {
                        measure_id: this.modalData.measureId,
                        questionMedia: this.questionMedia ? this.questionMedia : ''
                      };

                      this.createDetailMeasureByTypeInformant(form, data, valueInformant);

                    } else {
                      const data = {
                        id: this.modalData.id,
                        measure_id: this.modalData.measureId,
                        questionMedia: this.questionMedia ? this.questionMedia : ''
                      };

                      this.editMeasureQuestionInformantByType(form, data, valueInformant);
                    }
                  }
                }).start();
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
            break;
          } else {
            // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
            if (!this.modalData.id) {
              const data = {
                measure_id: this.modalData.measureId,
                questionMedia: this.questionMedia ? this.questionMedia : ''
              }

              this.createDetailMeasureByTypeInformant(form, data, valueInformant);

            } else {
              const data = {
                id: this.modalData.id,
                measure_id: this.modalData.measureId,
                questionMedia: this.questionMedia ? this.questionMedia : ''
              };

              this.editMeasureQuestionInformantByType(form, data, valueInformant);
            }
          }
          break;
        }

        // case 'Multi': {
        //   // console.log(this.multiFormArray);

        //   if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.unlimit && !form.value.time_again)) {
        //     alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้ Multi');
        //   } else if (this.multiFormArray.controls.length <= 1) {
        //     alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป Multi');
        //   }
        //   break;
        // }
      }
    } else {
      alert('คำถามหรือตัวเลือกของ informant ยังว่างอยู่ กรุณากรอกให้ครบ');
    }
  }

  createDetailMeasureByTypeInformant(form, data, valueInformant) {
    console.log(form);
    this.measureManagementService.createDetailMeasureByTypeInformant(form.value, data, valueInformant).pipe(
      map(res => {
        if (res.success) {
          this.dialogRef.close({ status: true });
          this.isLoading = false;
        }
      }),
      catchError((err) => {
        alert(err.error.message)
        this.isLoading = false;
        return of(null);
      })
    ).subscribe();
  }

  editMeasureQuestionInformantByType(form, data, valueInformant) {
    console.log(form);
    this.measureManagementService.editMeasureQuestionInformantByType(form.value, data, valueInformant).pipe(
      map(res => {
        if (res.success) {
          this.isLoading = false;
          this.dialogRef.close({ status: true });
        }
      }),
      catchError((err) => {
        alert(err.error.message)
        this.isLoading = false;
        return of(null);
      })
    ).subscribe();
  }

  editQuestionList(form) {
    let isEmpty = false
    console.log(form);
    let valueInformant = [];
    valueInformant.push({
      tag: 'Traget',
      ...form.value
    });

    this.informantArr.forEach(e => {
      valueInformant.push(e);
    })
    console.log(valueInformant);

    for (let i = 0; i < valueInformant.length; i++) {
      let question = valueInformant[i]
      if (!question.question) {
        isEmpty = true;
        break;
      } else {
        for (let j = 0; j < question.choices.length; j++) {
          const choice = question.choices[j];
          if (!choice.choice_detail) {
            isEmpty = true;
            break;
          }
        }
      }
    }

    if (!isEmpty) {
      switch (this.type) {
        case 'multi_choice': {
          if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
            alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
            break;
          } else if (form.value.choices.length <= 1) {
            alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
            break;
          }

          form.controls['type'].setValue('multi_choice');
          this.isLoading = true;

          if (this.questionMediaType === 'mp4') {
            this.eLearningService.createVideo(this.questionMedia).pipe(
              map(response => {
                const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
                this.pendingFiles.push(videoFile);
                this.uploadVideoUri = response.body.uri.slice(8);
                this.hashKey = response.body.link.slice(-10);

                return new tus.Upload(this.pendingFiles[0].video, {
                  uploadUrl: this.pendingFiles[0].uploadURI,
                  endpoint: this.pendingFiles[0].uploadURI,
                  retryDelays: [0, 1000, 3000, 5000],
                  onError: error => {
                    // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                    return of(null)
                  },
                  onProgress: (bytesUploaded, bytesTotal) => {
                    this.percentage = ((bytesUploaded / bytesTotal) * 100);
                    const percentage = ((bytesUploaded / bytesTotal) * 100);
                    // console.log(bytesUploaded, bytesTotal, percentage + '%');
                  },
                  onSuccess: () => {
                    // console.log('Videos uploaded successfully');

                    form.controls['media'].patchValue({
                      file_name: this.uploadVideoUri
                    });
                    form.controls['media'].updateValueAndValidity();
                    this.questionMedia = '';

                    const data = {
                      id: this.modalData.value.ID,
                      measure_id: this.modalData.measureId,
                      questionMedia: this.questionMedia ? this.questionMedia : '',
                      choicesMedia: this.choicesMedia ? this.choicesMedia : ''
                    };

                    this.editMeasureQuestionInformantByType(form, data, valueInformant);
                  }
                }).start();
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
            break;
          } else {
            const data = {
              id: this.modalData.value.ID,
              measure_id: this.modalData.measureId,
              questionMedia: this.questionMedia ? this.questionMedia : '',
              choicesMedia: this.choicesMedia ? this.choicesMedia : ''
            }

            if (form.value.media.vdo_id) {
              form.value.media.file_name = form.value.media.vdo_id;

              valueInformant.forEach(el => {
                el.media.file_name = form.value.media.vdo_id;
              });
            }

            this.editMeasureQuestionInformantByType(form, data, valueInformant);
          }
          break;
        }

        case 'rating': {
          // console.log(form);

          form.controls['type'].setValue('rating');

          const data = {
            id: this.modalData.value.ID,
            measure_id: this.modalData.measureId
          }
          this.editMeasureQuestionInformantByType(form.value, data, valueInformant);
          break;
        }

        case 'ranking': {
          if (form.value.choices.length <= 1) {
            alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
            break;
          }
          // console.log(form);

          form.controls['type'].setValue('ranking');

          const data = {
            id: this.modalData.value.ID,
            measure_id: this.modalData.measureId
          };

          this.editMeasureQuestionInformantByType(form, data, valueInformant);
          break;
        }

        case 'most/least': {
          if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
            alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
            break;
          } else if (form.value.choices.length <= 1) {
            alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
            break;
          }

          form.controls['type'].setValue('most/least');
          this.isLoading = true;

          if (this.questionMediaType === 'mp4') {
            this.eLearningService.createVideo(this.questionMedia).pipe(
              map(response => {
                const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
                this.pendingFiles.push(videoFile);
                this.uploadVideoUri = response.body.uri.slice(8);
                this.hashKey = response.body.link.slice(-10);

                return new tus.Upload(this.pendingFiles[0].video, {
                  uploadUrl: this.pendingFiles[0].uploadURI,
                  endpoint: this.pendingFiles[0].uploadURI,
                  retryDelays: [0, 1000, 3000, 5000],
                  onError: error => {
                    // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                    return of(null)
                  },
                  onProgress: (bytesUploaded, bytesTotal) => {
                    this.percentage = ((bytesUploaded / bytesTotal) * 100);
                    const percentage = ((bytesUploaded / bytesTotal) * 100);
                    // console.log(bytesUploaded, bytesTotal, percentage + '%');
                  },
                  onSuccess: () => {
                    // console.log('Videos uploaded successfully');

                    form.controls['media'].patchValue({
                      file_name: this.uploadVideoUri
                    });
                    form.controls['media'].updateValueAndValidity();
                    this.questionMedia = '';

                    const data = {
                      id: this.modalData.id,
                      measure_id: this.modalData.measureId,
                      questionMedia: this.questionMedia ? this.questionMedia : ''
                    };

                    this.editMeasureQuestionInformantByType(form, data, valueInformant);
                  }
                }).start();
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
            break;
          } else {
            const data = {
              id: this.modalData.id,
              measure_id: this.modalData.measureId,
              questionMedia: this.questionMedia ? this.questionMedia : ''
            };

            if (form.value.media.vdo_id) {
              form.value.media.file_name = form.value.media.vdo_id;

              valueInformant.forEach(el => {
                el.media.file_name = form.value.media.vdo_id;
              });
            }

            this.editMeasureQuestionInformantByType(form, data, valueInformant);
          }
          break;
        }
      }
    } else {
      alert('คำถามหรือตัวเลือกของ informant ยังว่างอยู่ กรุณากรอกให้ครบ');
    }
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }
}